import { Avatar, Box, Checkbox, Divider, Form, Grid, Text } from '@approvalmax/ui/src/components';
import { memo } from 'react';
import bemFactory from 'react-bem-factory';

import { WatcherItemProps } from './WatcherItem.types';

const qa = bemFactory.qa('reql-edit-watchers-popup-item');

export const WatcherItem = memo<WatcherItemProps>((props) => {
    const { readonly, user } = props;

    return (
        <Form.Part>
            <Box key={user.databaseId} data-qa={qa()} data-qa-id={user.databaseId}>
                <Grid gridTemplateColumns=' max-content max-content auto' gap={12} alignItems='center' padding='4 0'>
                    <Checkbox name={`watchers.${user.databaseId}`} disabled={readonly} />

                    <Avatar alt={user.displayName} src={user.avatar} size={40} />

                    <Text font='label' fontSize='small' color='midnight100'>
                        {user.displayName}
                    </Text>
                </Grid>

                <Divider />
            </Box>
        </Form.Part>
    );
});

WatcherItem.displayName = 'WatcherItem';
